import { ExpressCheckoutUI } from "./ExpressCheckoutUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";

export function ExpressCheckout({ product }: Pick<StandardProps, "product">) {
  const productId = product.aliases.pimProductId;
  const { variant } = useVariant(product);

  return <ExpressCheckoutUI productId={productId} variantId={variant.id} />;
}
